import { PageLoadingIndicator } from '@wrisk/ui-components'
import React, { FunctionComponent, PropsWithChildren } from 'react'

import { useApiErrorHandlingAsync } from '../../../../hooks/auth'
import { usePrincipal } from '../../../authentication'
import { CustomerAccountProvider } from '../../policy/billing/CustomerAccountProvider'
import { PaymentMethodsProvider } from '../../policy/billing/PaymentMethodsProvider'
import { useProposal } from '../ProposalProvider'

export const PaymentManager: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const { apiClient } = usePrincipal()
  const { proposal } = useProposal()

  const { result, loading } = useApiErrorHandlingAsync(async () => {
    const paymentMethods = await apiClient.getPaymentMethods()

    const [customerAccount] = await apiClient.getCustomerAccounts({
      policyNumber: proposal.policyNumber,
    })

    return { customerAccount, paymentMethods }
  }, [proposal])

  if (loading || !result) {
    return <PageLoadingIndicator />
  }

  return (
    <PaymentMethodsProvider paymentMethods={result.paymentMethods}>
      <CustomerAccountProvider customerAccount={result.customerAccount}>
        {children}
      </CustomerAccountProvider>
    </PaymentMethodsProvider>
  )
}
